import type { IExercise } from '../exercises';

export const ARCHIVED_WARMUP_TEACHINGS: IExercise[] = [
  {
    "id": "band-shoulder-warmup",
    "name": "弹力带肩部热身",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "shoulder",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/gifs/band-shoulder-warmup",
    "videoUrl": "/media/videos/band-shoulder-warmup",
  },
  {
    "id": "ksw-warmup-wrist-activation",
    "name": "手腕激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["手腕做前后左右环绕+屈伸","充分活动腕关节，预防卧推受伤"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-wrist-activation",
    "videoUrl": "/media/videos/ksw-warmup-wrist-activation",
  },
  {
    "id": "ksw-warmup-band-shoulder-circles",
    "name": "弹力带绕肩",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "激活",
    "tips": ["弹力带两端握手上，直臂前后绕肩","动作缓慢流畅，激活肩关节活动度"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-band-shoulder-circles",
    "videoUrl": "/media/videos/ksw-warmup-band-shoulder-circles",
  },
  {
    "id": "ksw-warmup-thoracic-flexion",
    "name": "胸椎屈曲激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["跪位或站姿，做胸椎屈曲-伸展","打开胸椎活动度，提升划船动作质量"],
    "sets": 2,
    "reps": "10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-thoracic-flexion",
    "videoUrl": "/media/videos/ksw-warmup-thoracic-flexion",
  },
  {
    "id": "ksw-warmup-ankle-activation",
    "name": "脚踝激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["脚踝做环绕+提踵+内外翻","充分活动踝关节，提升深蹲稳定性"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-ankle-activation",
    "videoUrl": "/media/videos/ksw-warmup-ankle-activation",
  },
  {
    "id": "personal-s2-prep",
    "name": "训练前准备",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["活动肩袖与胸椎","为背部训练做准备"],
    "sets": 1,
    "reps": "3分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-prep",
    "videoUrl": "/media/videos/personal-s2-prep",
  },
  {
    "id": "personal-s2-ab-wheel-foam",
    "name": "健腹轮泡沫轴",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "core",
    "tips": ["放松前侧核心肌群","缓慢滚动不憋气"],
    "sets": 1,
    "reps": "2分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-ab-wheel-foam",
    "videoUrl": "/media/videos/personal-s2-ab-wheel-foam",
  },
  {
    "id": "fanjue-spider-warmup",
    "name": "蜘蛛式热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["髋部下沉","动态拉伸髋屈肌"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-spider-warmup",
    "videoUrl": "/media/videos/fanjue-spider-warmup",
  },
  {
    "id": "fanjue-rotator-cuff-activation",
    "name": "肩袖激活",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "shoulder",
    "tips": ["弹力带外旋内旋","肩袖肌群预热"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-rotator-cuff-activation",
    "videoUrl": "/media/videos/fanjue-rotator-cuff-activation",
  },
  {
    "id": "fanjue-side-band-walk",
    "name": "侧向移动弹力带",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "hip-leg",
    "tips": ["侧步走激活臀中肌","弹力带始终张力"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-side-band-walk",
    "videoUrl": "/media/videos/fanjue-side-band-walk",
  },
];
